module.exports = __webpack_public_path__ + "static/media/bio.a7e3758c.jpg";